<template>
  <v-container>
    <!-- Botón para abrir el menú -->
    <v-menu>
      <template v-slot:activator="{ props }">
        <v-btn icon v-bind="props">
          <img
            :src="getFlag(selectedLanguage)"
            alt="Idioma seleccionado"
            width="24"
            height="16"
          />
        </v-btn>
      </template>

      <!-- Opciones de idioma -->
      <v-list>
        <v-list-item
          v-for="lang in languages"
          :key="lang.value"
          @click="changeLanguage(lang.value)"
        >
          <v-list-item-avatar>
            <img :src="lang.flag" alt="Bandera" />
          </v-list-item-avatar>
          <v-list-item-title>{{ lang.text }}</v-list-item-title>
        </v-list-item>
      </v-list>
    </v-menu>
  </v-container>
</template>

<script>
export default {
  data() {
    return {
      selectedLanguage: this.$i18n.locale, // Idioma actual
      languages: [
        { text: 'English', value: 'en', flag: 'https://flagcdn.com/w40/gb.png' },
        { text: 'Español', value: 'es', flag: 'https://flagcdn.com/w40/es.png' },
        
      ],
    };
  },
  methods: {
    changeLanguage(language) {
      this.selectedLanguage = language; // Cambiar la bandera seleccionada
      this.$i18n.locale = language; // Cambiar el idioma
    },
    getFlag(language) {
      const lang = this.languages.find((l) => l.value === language);
      return lang ? lang.flag : ''; // Retorna la URL de la bandera
    },
  },
};
</script>

<style scoped>
/* Opcional: ajusta los estilos de las banderas */
img {
  border-radius: 3px;
}
</style>
